<template>
  <div>
    <v-dialog v-model="dialog" max-width="800" max-heigth="300">
      <v-card>
        <v-card-text>
          <AttachmentWidget
            ref="attchWidget"
            :key="attachmentUpdates"
            :entity-id="entityId"
            :entry-id="entryId"
          ></AttachmentWidget></v-card-text></v-card
    ></v-dialog>
    <div class="dividersClass">
      <QueryTableWidget
        v-if="qid != null"
        :key="updates"
        ref="form"
        :query-id="qid"
        :title="
          typeof title === 'string' ? title : title != null ? title.text : null
        "
        :title-class="
          typeof title === 'string' ? null : title != null ? title.class : null
        "
        :select-all="selectAll"
        :hard-filters="hardFilters"
        :rows-per-page="rowsPerPage"
        :rows-per-page-items="rowsPerPageItems"
        :default-sort="defaultSort"
        :csv-export="csvExport"
        :date-today="dateToday"
        :form-specs="formSpecs"
        @rowClick="clicked"
        @deleteClicked="deleteEntity"
        @showAttachment="showAttachment"
      />
    </div>
    <v-btn v-if="mode === 'full'" color="#efca31" @click="redirectToAdd"
      >Adaugă</v-btn
    >
    <v-btn v-if="mode === 'full'" color="normal" @click="exportCSV"
      >Exportă CSV</v-btn
    >
    <v-btn v-if="mode === 'full'" color="normal" @click="exportPDF"
      >Exportă PDF</v-btn
    >
  </div>
</template>

<script>
import ApiService from '../APIService.js'

export default {
  name: 'ListForm',
  components: {
    QueryTableWidget: () => import('../leaf_widgets/QueryTableWidget.vue'),
    AttachmentWidget: () => import('../complex_widgets/AttachmentWidget.vue')
  },
  props: {
    queryId: {
      type: String,
      default: null
    },
    entityId: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: 'full'
    },
    selectAll: {
      type: Boolean,
      default: false
    },
    hardFilters: {
      type: Object,
      default: null
    },
    rowsPerPage: {
      type: Number,
      default: null
    },
    rowsPerPageItems: {
      type: Array,
      default: null
    },
    defaultSort: {
      type: Object,
      default: null
    },
    csvExport: {
      type: Boolean,
      default: null
    },
    title: {
      type: [String, Object],
      default: null
    },
    dateToday: {
      type: [Date, String],
      default: null
    },
    formSpecs: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      attachmentUpdates: 0,
      qid: this.queryId,
      selectedIndex: -1,
      updates: 0,
      clicks: 0,
      dialog: false,
      entryId: '',
      coloring: null
    }
  },
  created() {
    if (this.qid == null) {
      ApiService.getForm(this.entityId, 'list')
        .then((res) => {
          this.qid = res.data.queryId
          this.updates++
        })
        .catch((ex) => {
          console.log('Could not fetch list form entity: ' + this.entityId)
          console.log(ex)
        })
    }
  },
  methods: {
    showAttachment(value) {
      this.entryId = value._id
      this.attachmentUpdates++
      this.dialog = true
    },
    exportCSV() {
      this.$refs.form.exportCSV()
    },
    exportPDF() {
      this.$refs.form.exportPDF()
    },
    deleteEntity(value) {
      if (value._id !== null) {
        this.clicks = 1
        if (
          confirm('Sunteti sigur ca vreti sa continuati aceasta operatiune?')
        ) {
          ApiService.deleteEntry(this.entityId, value._id).then((res) => {
            if (res.response && res.response.status === 401) {
              this.$notify({
                group: 'notifications',
                type: 'error',
                title: 'Eroare',
                text: 'Nu sunteti autorizat sa efectuati aceasta actiune!'
              })
            } else if (res.status >= 200 && res.status <= 299) {
              this.$notify({
                group: 'notifications',
                type: 'error',
                title: 'DELETE',
                text: 'Entitatea s-a sters'
              })
              this.updates++
            }
          })
        }
      }
    },
    redirectToAdd() {
      this.$router.push({
        name: 'FormView',
        params: {
          entityId: this.entityId,
          formType: 'crud'
        }
      })
    },
    clicked(value) {
      if (this.clicks === 0) {
        this.$emit('rowClick', value)
        if (this.mode === 'full') {
          const entryId = value._id
          this.$router.push({
            name: 'UpdateForm',
            params: {
              entityId: this.entityId,
              formType: 'crud',
              entryId: entryId
            }
          })
        }
      }
      this.clicks = 0
    }
  }
}
</script>
